<div class="main-layout">
    <!-- Navbar at the top -->
    <div class="main-layout__navbar">
        <app-navbar (selectionChange)="onSelectionChange($event)"></app-navbar>

        <!-- Sub Navbar, to show this add the routerLink to the sub-navbar constants -->
        @if (showSubNavbar()) {
            <app-sub-navbar
                [title]="selectedModule().label"
                [parent]="selectedModule().parent"
                [url]="selectedModule().url">
            </app-sub-navbar>
        }
    </div>

    <!-- Main content area - this is where page content loads -->
    <main class="main-layout__content" [class.overflow-hidden]="overflowHidden()">
        <router-outlet></router-outlet>
    </main>

    <!-- Cross-tab Logout Notice Modal -->
    @if (authService.showLogoutNoticeModal()) {
        <app-confirmation-modal
            data-testid="cross-tab-logout-notice"
            [isVisible]="true"
            type="warning"
            title="You've been logged out"
            message="Your session ended in another tab or window. Click continue to return to the login page."
            confirmText="Continue to login"
            [showCancelButton]="false"
            (confirm)="authService.dismissLogoutNotice()"
            (modalClose)="authService.dismissLogoutNotice()" />
    }
</div>
